import ShippingViewController from './ShippingViewController';

export default ShippingViewController;
